export { default as GtmBody } from './GtmBody';
export { default as GtmHead } from './GtmHead';
export { default as PgDataLayer } from './PgDataLayer';
export { default as SeoSchema } from './SeoSchema';
export { default as Canonical } from './Canonical';
